/**
 * Build a usable `<img>` src from a value that could be:
 * - A `data:` URL (returned as-is)
 * - A full `http://` / `https://` URL (returned as-is)
 * - A protocol-relative `//host/...` URL (prefixed with `https:`)
 * - A raw base64 string (no prefix — our DB convention for `User.image`),
 *   which we wrap as `data:image/jpeg;base64,…`
 *
 * Don't trigger off a leading "/" — JPEG base64 always starts with `/9j/`,
 * which would be misread as a same-origin path and 404 in the browser.
 */
export function resolveImageSrc(image: string | null | undefined): string {
  if (!image) return '';
  const trimmed = image.trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('data:')) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;

  return `data:image/jpeg;base64,${trimmed}`;
}
